import { render } from "./TextBlockPreview.vue?vue&type=template&id=4fe54b64"
import script from "./TextBlockPreview.vue?vue&type=script&lang=js"
export * from "./TextBlockPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__